module.exports = __webpack_public_path__ + "media/categories/210-75376c10.svg";